const active = "-active";

export {active}
